import React from "react";
import { Col, Container, Row, Tabs, Tab } from "react-bootstrap";

const Technologygcc = () => {
  return (
    <div className="tekrevol_gray_bg tabing_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6}>
            <h2>Our Tech Stack for Full-Fledged Mobile App Development in Bahrain</h2>
          </Col>
          <Col xs={12} md={6} lg={6}>
            <p>
            We believe in continual progress in the field of mobile app development to stay ahead in the market. For that purpose, we adapt every new technology that innovates the process of app development in Bahrain. Whether you need a native or cross-platform app or a robust gaming application, we have the right tech stack to facilitate you. It not only makes us the first choice for business but also elevates the position of our clients in the market. 
            </p>
          </Col>
        </Row>
        <Row>
          <Tabs defaultActiveKey="1" id="uncontrolled-tab-example">
            <Tab eventKey="1" title="Mobile Frontend">
              <ul>
                <li>React Native</li>
                <li>Flutter</li>
                <li>Swift (iOS)</li>
                <li>Kotlin (Android)</li>
              </ul>
            </Tab>
            <Tab eventKey="2" title="SDKs/Tools/Framework">
              <ul>
                <li>Firebase</li>
                <li>Redux</li>
                <li>Alamofire (iOS)</li>
                <li>Retrofit (Android)</li>
              </ul>
            </Tab>
            <Tab eventKey="3" title="Operating System">
              <ul>
                <li>iOS</li>
                <li>Android</li>
              </ul>
            </Tab>
            <Tab eventKey="4" title="Platforms">
              <ul>
                <li>App Store (iOS)</li>
                <li>Google Play (Android)</li>
              </ul>
            </Tab>
            <Tab eventKey="5" title="Others">
              <ul>
                <li>Git</li>
                <li>RESTful APIs</li>
                <li>JSON</li>
                <li>Gradle (Android)</li>
                <li>Xcode (iOS)</li>
                <li> Android Studio (Android)</li>
              </ul>
            </Tab>
          </Tabs>
        </Row>
      </Container>
    </div>
  );
};

export default Technologygcc;
